import endpoints from '../endpoints'; // or wherever your endpoints file is
import axiosInstance from '../axios';

const hostService = {
  // Get current user's hosts (COMPANY_ADMIN gets their own)
  getMyHosts: async (params = {}) => {
    const { page = 1, pageSize = 10 } = params;
    const queryParams = new URLSearchParams({ page, pageSize });
    
    const response = await axiosInstance.get(`${endpoints.hosts.list}?${queryParams}`);
    return response.data;
  },

  // Get ALL hosts (Super Admin only) - YOU NEED TO ADD THIS TO endpoints.js
  getAllHosts: async (params = {}) => {
    const { page = 1, pageSize = 10 } = params;
    const queryParams = new URLSearchParams({ page, pageSize });
    
    const response = await axiosInstance.get(`/hosts/admin/all?${queryParams}`);
    return response.data;
  },

  getHostById: async (hostId) => {
    const response = await axiosInstance.get(endpoints.hosts.getById(hostId));
    return response.data;
  },

  createHost: async (formData) => {
    const response = await axiosInstance.post(endpoints.hosts.create, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateHost: async (hostId, formData) => {
    const response = await axiosInstance.put(endpoints.hosts.update(hostId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteHost: async (hostId) => {
    const response = await axiosInstance.delete(endpoints.hosts.delete(hostId));
    return response.data;
  },

  toggleHostStatus: async (hostId) => {
    const response = await axiosInstance.patch(`/hosts/${hostId}/toggle-status`);
    return response.data;
  },

   transferHostOwnership: async (hostId, newOwnerId) => {
    const response = await axiosInstance.post(endpoints.hosts.transfer(hostId), {
      newOwnerId
    });
    return response.data;
  }
};

export default hostService;